<template>
  <div>

    <el-collapse-transition>
      <div v-show="advanceS">
        <el-container>
          <el-main class="content">
            <el-row>
              <el-col>
                <el-form  :inline="true">
                  <slot name="form-item"></slot>
<!--                  <el-form-item label="">
                    &lt;!&ndash;<label class="labelName">&nbsp</label>&ndash;&gt;
                    <el-button class="search-b" @click="search()" style="margin:0 10px 0 10px">查询</el-button>
                    <el-button plain @click="reset()">重置</el-button>
                  </el-form-item>-->
                </el-form>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </div>
    </el-collapse-transition>
    <div class="flex mb10">
      <el-button class="search-b" @click="search()" >查询</el-button>
      <el-button plain @click="reset()">重置</el-button>
    </div>
    <div class="searchBox">
      <div class="search-btn-box" >
        <slot></slot>&nbsp;
      </div >
      <div class="search-input-box">
        <slot name="input"></slot>
        <!-- <simple-dict v-if="dictType" :dictType="dictType" @keyup.enter.native="search()" is-all="" :model-value="inputValue" @update:modelValue="changeInput" style="width:260px"></simple-dict>
        <el-input v-else="" style="width:260px" v-model="inputValue" :placeholder="placeholder"  @keyup.enter.native="search()">
          <template #append>
            <el-button @click="search()" :class="{'active':inputValue}" :disabled="advanceS"  class="advance-Button">搜索</el-button>
          </template>
        </el-input>
        <div v-show="$slots['form-item']" class="advance_search" @click="baseAdvanceSearch()" :class="{active: advanceS === true}"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
  import SimpleDict from "../dict/SimpleDict";
  export default {
    name: "search-box",
    components: {SimpleDict},
    props:['placeholder','modelValue','dictType'],
    data() {
      return {
        advanceS:true,
        inputValue:''
      }
    },
    watch:{
      modelValue: function(newValue) {
        this.inputValue = newValue;
      },
      inputValue:function(newValue){
        this.$emit('update:modelValue', newValue);
      },

    },
    mixins: [tableBase],
    methods: {
      loadData(){
        this.$emit('action');
      },
      reset(){
        this.$emit('reset-search');
      },
      changeInput(value){
        this.inputValue = value|| '';
        this.search();
      }
    },
    mounted() {
      this.inputValue = this.value || '';
    }
  }
</script>


<style lang="less" scoped>
.content{
  overflow: visible;
  padding: 0 !important;
}
  .search-b{
    background-color: @primary !important;
    color: #ffffff;
  }
.searchBox{
  padding: 0 0px 12px;
  display: flex;
  flex-wrap: wrap;
  .search-btn-box{
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    //margin-bottom: 10px;
  }

}


</style>
